<template>
  <div v-if="Boolean(blocks.length)" class="block-renderer">
    <BaseBlockRenderer
      v-for="item in sanitizedData"
      :key="item.blockType"
      :block-type="item.blockType"
      :data="item.data"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useCmsApi } from '~/composables';
import type { SnippetBlock } from '~/types';
import BaseBlockRenderer from '~/components/BaseBlockRenderer.vue';

const { fetchFromCMSClientSide } = useCmsApi();
const blocks = ref<SnippetBlock[]>([]);
await init();

const sanitizedData = computed(() => {
  return blocks.value.map(item => ({
    blockType: item.type,
    data: item.value,
  }));
});

async function init () {
  try {
    const data = await fetchFromCMSClientSide('/block_list/find/?code=subscription_car_details');
    blocks.value = data.blocks;
  } catch (error: any) {
    if (error?.name === 'FetchError') {
      // This means that there is no block yet
      return;
    }
    // eslint-disable-next-line no-console
    console.log('[CarDetailsBlockRenderer] error:', JSON.parse(JSON.stringify(error)));
  }
}
</script>
